import { render } from "./uploadtask.vue?vue&type=template&id=10dd83f0&scoped=true"
import script from "./uploadtask.vue?vue&type=script&lang=js"
export * from "./uploadtask.vue?vue&type=script&lang=js"

import "./uploadtask.vue?vue&type=style&index=0&id=10dd83f0&lang=less&scoped=true"

import exportComponent from "/Users/yangjinlong/shthn/zzdxs-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10dd83f0"]])

export default __exports__